module.exports = __webpack_public_path__ + "img/settings-active.1409fc8c.svg";